import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import React, {useEffect, useState} from "react";
import {Box, CircularProgress, Stack} from "@mui/material";
import CompanyForm from "../../components/CompanyForm";
import {api} from "../../services/apiService";


export default function Settings() {
    const [loaded, setLoaded] = useState(false);
    const [initialData, setInitialData] = useState({
        companyName: "",
        siret: "",
        tva: "",
        email: "",
        phone: "",
        address: "",
        postalCode: "",
        city: "",
        picture_path: ""
    });

    useEffect(() => {
        api.get('companies/details')
            .then((response) => {
                const companyData = response.data;
                // Préparer les données initiales pour le formulaire
                if (companyData) {
                    setInitialData({
                        companyName: companyData.name || "",
                        siret: companyData.siret || "",
                        tva: companyData.tva || "",
                        email: companyData.email || "",
                        phone: companyData.phone || "",
                        address: companyData.address || "",
                        postalCode: companyData.postal_code || "",
                        city: companyData.city || "",
                        picture_path: companyData.picture_path || ""
                    });
                }
            })
            .catch((error) => {
                console.error("Erreur lors du chargement des détails de l'entreprise :", error);
            })
            .finally(() => {
                setLoaded(true);
            });
    }, []);

    const handleSubmit = (data, logo) => {
        const formData = new FormData();

        if (logo) {
            formData.append('logo', logo);
        }

        // on envoie le JSON sérialisé dans un champ 'data'
        formData.append('data', JSON.stringify(data));

        // axios gère normalement le boundary automatiquement, mais on peut forcer le type multipart/form-data
        return api.put(`/companies/edit`, formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        }).then(() => {
            alert("Entreprise modifiée avec succès !");
        }).catch(err => {
            alert("Erreur lors de la création de l'entreprise : " + err.message);
        });
    }

    return (
        loaded ? (
                <Container>
                    <Typography variant="h1" gutterBottom>Paramètres</Typography>

                    <CompanyForm initialData={initialData} onSubmit={handleSubmit}/>
                </Container>
            )
            : (
                <Container maxWidth="lg"
                           sx={{mt: 4, display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh"}}>
                    <Stack spacing={2} alignItems="center">
                        <Box>
                            <Typography variant="h6" sx={{mb: 2}}>Chargement des détails...</Typography>
                            <Box sx={{display: "flex", justifyContent: "center"}}>
                                <CircularProgress color="primary"/>
                            </Box>
                        </Box>
                    </Stack>
                </Container>
            )
    )
}